/* eslint-disable @typescript-eslint/no-explicit-any */

import { ResizeBox } from "@/components/shared/resize-box";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
// import {
//   /* EyeIcon */ /* MonitorPlay, */ /* Trash2Icon ,*/
//   LucideLoaderCircle,
//   // FileText,
//   RotateCcw,
// } from "lucide-react";
import { ReactTableCell } from "../react-table-cell/react-table-cell";
import { SwitchRenderer } from "@/components/shared/switch-renderer";
import { ReactTableHeader } from "@/components/shared/react-table-header";
import { CustomReactTableHeader } from "@/components/shared/custom-react-table-header";
// import { ReprocessDocument } from "../reprocess-document/reprocess-document";
import { ViewButton } from "../view-button/view-button";
// import { ReprocessErp } from "../reprocess-erp";
import { ReprocessCombo } from "../reprocess-combo";
import { Trash2Icon } from "lucide-react";
import { VoidDocumentList } from "../void-document-list/void-document-list";
export const ReactTable = ({
  tableHeader,
  onResize,
  table,
  onAction,
  retailerList,
  filter,
  setFilter,
  listData,
  filterRequest,
  workflowList,
  currentCompanyData,
  reprocessDocumentId,
  // reprocessErpId,
  company_id,
  user_id,
  loadingList,
  activePermission,
  allRetailerList,
}: any) => {
  return (
    <Table style={{ borderCollapse: "collapse", width: "100%" }}>
      <TableHeader>
        <TableRow>
          <TableHead className="hidden">
            <input type="checkbox" />
          </TableHead>
          {tableHeader?.map((header: any, index: number) => (
            <TableHead
              key={header.accessorKey}
              style={{
                width: header.width,
                minWidth: header.minWidth,
                maxWidth: header.maxWidth,
              }}
              className={cn({ "pl-5": index === 0 })}
            >
              <ResizeBox
                width={header.width}
                onResize={(props: any) =>
                  onResize({ size: props, key: header.accessorKey })
                }
              >
                <SwitchRenderer
                  type={header.header}
                  components={{
                    "Retailer id": (
                      <CustomReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={retailerList}
                        setFilter={setFilter}
                        filter={filter}
                        bindLabel="retailer_name"
                        bindValue="retailer_id"
                        isHide={listData?.length === 0}
                        filterRequest={filterRequest}
                      >
                        <span>Retailer Name</span>
                      </CustomReactTableHeader>
                    ),
                    "Erp ref number": (
                      <ReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={listData}
                        setFilter={setFilter}
                        filter={filter}
                        filterRequest={filterRequest}
                      >
                        <span>SNC ref #</span>
                      </ReactTableHeader>
                    ),
                    "Doc type": <span>Document Type</span>,
                    "Erp info": <span>Erp ref #</span>,
                    "Source type": <span>Source</span>,

                    State: (
                      <ReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={listData}
                        setFilter={setFilter}
                        filter={filter}
                        filterRequest={filterRequest}
                        forceFilter={true}
                        list={[
                          "processing",
                          "processed",
                          "failed",
                          "pending",
                          "unsupported",
                          "on_hold",
                          "void",
                          "snc_success",
                          "snc_pending",
                          "erp_success",
                          "erp_failed",
                          "duplicate",
                          "validation_failed",
                          "erp_processed",
                        ]}
                      >
                        <span>Status</span>
                      </ReactTableHeader>
                    ),
                    "Erp status": (
                      <ReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={listData}
                        setFilter={setFilter}
                        filter={filter}
                        filterRequest={filterRequest}
                        forceFilter={true}
                        list={[
                          "erp_disabled",
                          "duplicate_order",
                          "erp_failed",
                          // "erp_processed",
                          "invalid_date_format",
                          "customer_mapping_not_found",
                          "prices_invalid",
                          "sku_mapping_not_found",
                          "uom_mapping_not_found",
                          "erp_status",
                          "snc_status",
                          "failed",
                          "validation_failed",
                          "user_review_done",
                        ]}
                      >
                        <span>Details </span>
                      </ReactTableHeader>
                    ),
                    Uts: <span>Processed On</span>,
                    "Erp customer name": <span>Erp Customer Name</span>,
                    "Reference number": <span>Reference #</span>,
                    default: (
                      <ReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={listData}
                        setFilter={setFilter}
                        filter={filter}
                        filterRequest={filterRequest}
                      >
                        <span>{header.header}</span>
                      </ReactTableHeader>
                    ),
                  }}
                />
              </ResizeBox>
            </TableHead>
          ))}
          <TableHead className="text-center sticky right-0 z-[2] w-auto pr-0">
            <div className="flex justify-end">
              <div className="w-[150px] pl-[10px] text-left">Actions</div>
            </div>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {table.map((row: any, rowIndex: number) => (
          <TableRow key={row.id + rowIndex}>
            <TableCell className="w-[30px] hidden">
              <input type="checkbox" />
            </TableCell>
            {row.data.map((cell: any, index: number) => (
              <TableCell
                key={cell.key + index}
                width={cell.width}
                style={{ width: cell.width }}
                className={cn({ "pl-3": index === 0 })}
                isLineClampDisable={cell.key === "erp_info"}
              >
                <ReactTableCell
                  header={cell.key}
                  value={cell.value}
                  retailerList={retailerList}
                  row={row}
                />
              </TableCell>
            ))}

            <TableCell
              className="text-right sticky right-0 w-auto bg-white"
              nestedClassName="pr-0"
            >
              <div className="flex pl-0">
                <div className="flex items-center justify-end z-[2] bg-white">
                  <div className="flex items-center w-[130px] pl-[0px]">
                    <TooltipProvider delayDuration={0}>
                      <ReprocessCombo
                        row={row}
                        company_id={company_id}
                        user_id={user_id}
                        workflowList={workflowList}
                        onAction={onAction}
                        reprocessDocumentId={reprocessDocumentId}
                        currentCompanyData={currentCompanyData}
                        loadingList={loadingList}
                        allRetailerList={allRetailerList}
                      />

                      <ViewButton row={row} onAction={onAction} />
                      {activePermission?.delete ? (
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <Button
                              variant={"ghost"}
                              size={"icon"}
                              className="text-primary"
                              // Deleted documents are read-only
                              disabled={row.originData?.is_deleted === true}
                              onClick={() =>
                                onAction({
                                  data: row.originData,
                                  action: "delete",
                                })
                              }
                            >
                              <Trash2Icon size={16} />
                            </Button>
                          </TooltipTrigger>

                          <TooltipContent>
                            <p>Delete</p>
                            <TooltipArrow />
                          </TooltipContent>
                        </Tooltip>
                      ) : null}
                    </TooltipProvider>
                    <VoidDocumentList
                      row={row}
                      onAction={onAction}
                      disabled={row.originData?.is_deleted === true}
                    />
                  </div>
                </div>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
